<template>
  <VLazyImage :src="src" :src-placeholder="imgLoading()" />
</template>
<script>
  import VLazyImage from "v-lazy-image/v2";
  export default {
    components: {
      VLazyImage,
    },
    props: ["src"],
    methods: {
      imgLoading() {
        return require("@/assets/loading.gif");
      },
    },
  };
</script>
